import { lsGet, lsStore } from 'oderon-vue/utils.js'
import PlotConfig from './PlotConfig'

export { init, getStr, setStr, findAll, togglePin, remove, fillMissingPlots }

const LS_STR_PLOT_CONFIGS = 'RawdataInspector_strPlotConfigs'
let _allPlots = []
let _serialized = null

function init() {
  _serialized = lsGet(LS_STR_PLOT_CONFIGS)
  _allPlots = parsePlotConfigs(_serialized)
  return getStr()
}

function findAll() {
  return _allPlots
}

function getStr() {
  return _serialized
}

function setStr(str) {
  _allPlots = parsePlotConfigs(str)
  _serialized = serialize(_allPlots)
  lsStore(LS_STR_PLOT_CONFIGS, str)
}

function togglePin(plotConfig) {
  plotConfig.isPinned = !plotConfig.isPinned
  _serialized = serialize(_allPlots)
  lsStore(LS_STR_PLOT_CONFIGS, _serialized)
}

function remove(plotConfig) {
  _allPlots = _allPlots.filter((x) => x.toString() != plotConfig.toString())
  _serialized = serialize(_allPlots)
  lsStore(LS_STR_PLOT_CONFIGS, _serialized)
}

function fillMissingPlots(allFrames) {
  const allVarCodes = findDistinctVariables(allFrames)
  const plotCombinations = computePlotCombinations(allVarCodes)

  let addedCount = 0
  for (let strPlot of plotCombinations) {
    if (!_allPlots.some((x) => x.toString() == strPlot)) {
      _allPlots.push(new PlotConfig(strPlot))
      addedCount++
    }
  }

  _serialized = serialize(_allPlots)
  lsStore(LS_STR_PLOT_CONFIGS, _serialized)

  return {
    totalVars: allVarCodes.length,
    totalPlots: plotCombinations.length,
    addedCount
  }
}

// ===================================

function parsePlotConfigs(str) {
  str = str && str.trim()
  if (str == null) return []

  const lines = str.split('\n').map((x) => x.trim())
  const pinIndex = lines.findIndex((l) => l.match(/^-{3,}/))

  let pinnedLines = []
  let otherLines = lines

  if (pinIndex != -1) {
    pinnedLines = lines.slice(0, pinIndex)
    otherLines = lines.slice(pinIndex + 1)
  }

  const allPlots = []
  for (let line of pinnedLines) {
    const plot = new PlotConfig(line)
    plot.isPinned = true
    allPlots.push(plot)
  }

  for (let line of otherLines) {
    allPlots.push(new PlotConfig(line))
  }

  return allPlots
}

function serialize(allPlots) {
  const lines = []

  const pinned = allPlots.filter((x) => x.isPinned)
  const other = allPlots.filter((x) => !x.isPinned)
  for (let plot of pinned) lines.push(plot.toString())
  if (pinned.length > 0) lines.push('-----')
  for (let plot of other) lines.push(plot.toString())

  return lines.join('\n')
}

function findDistinctVariables(frames) {
  const result = new Set()
  for (let frame of frames) {
    if (frame.type == 'event') {
      const sample = getSample(frame.event)
      for (let variable of sample || []) {
        result.add(variable.code)
      }
    } else if (frame.type == 'lapses') {
      for (let lapse of frame.lapses || []) {
        const sample = getSample(lapse)
        for (let variable of sample || []) {
          result.add(variable.code)
        }
      }
    }
  }

  return [...result].sort()
}

function getSample(lapse) {
  if (lapse.operations == null) return null
  const op = lapse.operations.find((x) => x.subTypeStr == 'sniff')
  if (op == null) return null
  return op.sample
}

function computePlotCombinations(variableCodes) {
  const result = []
  const p = (x) => x.toString().padStart(2, '0')
  for (let code of variableCodes) {
    for (let i = 0; i < 8; i++) {
      result.push(`${code} ${p(i * 8)} ${p((i + 1) * 8)}`)
    }
  }
  return result
}
